import Page from "@jumbo/shared/Page";
import ListSales from "app/pages/Sales/SalesList";
import SalesRouteMiddleware from "./middleware/auth/salesValidRoute";
import EditSales from "app/pages/Sales/SalesEdit";
import EditShopOrderSalesSales from "app/pages/Sales/ShopOrderSalesEdit";

export const salesRoutes = [
  {
    middleware: [
      {
        element: SalesRouteMiddleware,
        fallbackPath: "/dashboard",
      },
    ],
    routes: [
      {
        path: "/dashboard/sales",
        element: <Page component={ListSales} layout={"vertical-default"} />,
      },
      {
        path: "/dashboard/sales/edit",
        element: <Page component={EditSales} layout={"vertical-default"} />,
      },
      {
        path: "/dashboard/sales/edit-shop-order",
        element: <Page component={EditShopOrderSalesSales} layout={"vertical-default"} />,
      },
    ],
  },
];
